export namespace AnalyticEnums {

    export enum InteractionState {
        ImpressionLogged = 'data-impression-logged'
    }

}